import { z } from "zod";

/**
 * Centralized enums for the Nexus platform
 * Only enums that are NOT generated by Prisma should be defined here
 * Prisma-generated enums live on DbEnum (src/generated/prisma-enums.ts)
 */

/**
 * Parameter types as defined in the OpenAPI/JSON Schema specification.
 *
 * Use this enum when:
 * - Parsing external OpenAPI specifications
 * - Validating JSON Schema from third-party APIs
 * - Converting external tool definitions
 *
 * Note: INTEGER is distinct from NUMBER per JSON Schema spec (integers only vs decimals).
 *
 * @see {@link WorkflowParameterType} for internal workflow parameter types
 * @see {@link AllParameterType} for extended types (to be defined)
 */
export enum OpenAPIParameterType {
  STRING = "string",
  NUMBER = "number",
  INTEGER = "integer",
  BOOLEAN = "boolean",
  ARRAY = "array",
  OBJECT = "object"
}

/**
 * Extended parameter types for future use.
 *
 * TODO: Define the use case for this enum. Candidates:
 * - Rich form validation (EMAIL, URL, PHONE)
 * - Date/time handling (DATE, DATETIME)
 * - Structured data (JSON)
 *
 * @see {@link OpenAPIParameterType} for external API types
 * @see {@link WorkflowParameterType} for internal workflow parameter types
 */
export enum AllParameterType {
  STRING = "string",
  NUMBER = "number",
  INTEGER = "integer",
  BOOLEAN = "boolean",
  ARRAY = "array",
  OBJECT = "object",
  DATE = "date",
  DATETIME = "datetime",
  EMAIL = "email",
  URL = "url",
  PHONE = "phone",
  JSON = "json"
}

export const OpenAPIParameterTypeSchema = z.nativeEnum(OpenAPIParameterType);
